module.exports = __webpack_public_path__ + "img/54000.bbc1735f.jpg";